(function () {

  // ─── READ URL PARAMETER ───────────────────────────────────────
  const params = new URLSearchParams(window.location.search);
  const ad = params.get('ad');

  if (ad) {
    sessionStorage.setItem('bb_ad', ad);
  }

  const activeAd = ad || sessionStorage.getItem('bb_ad');

  if (activeAd) {
    document.documentElement.classList.add('bb-ad-visitor');
  }

  // ─── CART PAGE — SET PROPERTY FROM SESSION ────────────────────
  if (window.location.pathname === '/cart') {
    const cartSub = sessionStorage.getItem('bb_ad_cart_sub');
    const cartImage = sessionStorage.getItem('bb_ad_cart_image');

    if (cartImage) {
      const cartImg = document.querySelector('.cart-item__image');
      if (cartImg) {
        cartImg.src = cartImage;
        cartImg.srcset = cartImage;
      }
      sessionStorage.removeItem('bb_ad_cart_image');
    }

    if (cartSub) {
      fetch('/cart.js')
        .then(r => r.json())
        .then(async function(cart) {
          if (!cart.items.length) return;
          const lastItem = cart.items[0];

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: lastItem.key,
              properties: { '_ad_subline': cartSub }
            })
          });

          sessionStorage.removeItem('bb_ad_cart_sub');

          const cartSubEl = document.querySelector('.bb-cart-sub');
          if (cartSubEl) {
            cartSubEl.textContent = cartSub;
          } else {
            const nameEl = document.querySelector('.cart-item__name');
            if (nameEl) {
              const div = document.createElement('div');
              div.className = 'bb-cart-sub';
              div.textContent = cartSub;
              nameEl.insertAdjacentElement('afterend', div);
            }
          }
        });
    }
    return;
  }

  if (!activeAd) {
    document.documentElement.classList.add('bb-loaded');
    return;
  }

  // ─── DOM READY ────────────────────────────────────────────────
  function domReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // ─── PDP SWAPS ────────────────────────────────────────────────
  domReady(function () {

    if (!window.adConfigs || !window.adConfigs[activeAd]) {
      document.documentElement.classList.add('bb-loaded');
      return;
    }

    const config = window.adConfigs[activeAd];

    // Swap subline 1
    const subline1El = document.querySelector('.bb-craving-stack__headline');
    if (subline1El && config.subline1) {
      subline1El.innerHTML = config.subline1;
    }

    // Swap subline 2
    const subline2El = document.querySelector('.bb-craving-stack__descriptor');
    if (subline2El && config.subline2) {
      subline2El.innerHTML = config.subline2;
    }

    // Swap hero image
    if (config.image) {
      const heroImg = document.querySelector('.product__media img');
      if (heroImg) {
        heroImg.src = config.image;
        heroImg.srcset = config.image;
      }

      const firstThumb = document.querySelector('button.thumbnail img');
      if (firstThumb) {
        firstThumb.src = config.image;
        firstThumb.srcset = config.image;
      }

      if (config.hideThumbnail2) {
        const allThumbs = document.querySelectorAll('button.thumbnail');
        if (allThumbs[1]) {
          allThumbs[1].style.display = 'none';
        }
      }
    }

    // ─── MARK AS LOADED (reveals swapped elements) ────────────
    document.documentElement.classList.add('bb-loaded');

    // ─── INJECT HIDDEN INPUTS INTO FORM ──────────────────────
    const form = document.querySelector('form[action="/cart/add"]');
    const addBtn = document.querySelector('[name="add"]');

    if (form && config.cartSub) {

      const sublineInput = document.createElement('input');
      sublineInput.type = 'hidden';
      sublineInput.name = 'properties[_ad_subline]';
      sublineInput.value = config.cartSub;
      form.appendChild(sublineInput);

      if (addBtn) {
        addBtn.addEventListener('click', function() {
          if (config.cartImage) {
            sessionStorage.setItem('bb_ad_cart_image', config.cartImage);
          }
          sessionStorage.setItem('bb_ad_cart_sub', config.cartSub);
        });
      }
    }

  });

})();